<script>
export let params = {};
import Fa from 'svelte-fa'
import { faChevronRight } from '@fortawesome/free-solid-svg-icons';
let information = params.information||'';

import feathers from '../web_feathers.js';
const new_password = feathers.service('new_password');
let message;
let error;
let loading=false;
import Spinner from 'svelte-spinner';

async function request(){
	if(!information) return error='Please enter your account information to continue.';
	loading=true;
	message=error=null;
	const result = await new_password.create({information}).catch(e=>error=e.message)
	loading=false;
	if(error) return;
	message = 'We sent a link to your email address '+(result.redactedEmail||information)+'. Please check your email to access your account.';
	}

</script>



<main>

<form>

<div class="container">
	<div class="row justify-content-md-center">
		<div class="col-lg-6 col-md-8 col-s-12">
			<h2 class="ff-dunbar">Create Password</h2>
			</div>
			</div>
		<div class="row mt-3 justify-content-md-center">
		<div class="col-lg-6 col-md-8 col-s-12">
			<label for="account" class="ff-dunbar title-2">E-mail, Phone #, or SIM #</label><br>
			<input class="form-control" type="email" name="email" id="account" autocomplete="email" placeholder="E-mail, Phone #, or SIM #" bind:value={information}><br>
			<i>We will send a link to the email on file.</i>
		</div></div>

		<div class="row justify-content-md-center">
			<div class="mt-3 col-lg-6 col-md-8 col-s-12">
		<button disabled={loading} type="submit" class="btn btn-success form-control" on:click|preventDefault={request}>
			{#if loading} <Spinner /> {/if}
			Continue <Fa icon={faChevronRight}/>
			</button>
		</div></div>
	
		<div class="row justify-content-md-center">
			<div class="mt-3 col-lg-6 col-md-8 col-s-12">
		{#if message}
			<div class="alert alert-success">{message}</div>
		{:else if error}
			<div class="alert alert-danger">{error}</div>
		{/if}
			</div></div>

	</div>

	</form>

</main>
	